import { render, staticRenderFns } from "./CustomerGardenerNote.vue?vue&type=template&id=813dda44&scoped=true"
import script from "./CustomerGardenerNote.vue?vue&type=script&lang=js"
export * from "./CustomerGardenerNote.vue?vue&type=script&lang=js"
import style0 from "./CustomerGardenerNote.vue?vue&type=style&index=0&id=813dda44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813dda44",
  null
  
)

export default component.exports